import { memo } from 'react';
import { cn } from '@/lib/utils';
import { IPipelineStageBadgeProps, TLeadStatus } from '@/@types/leads';

const stageConfig: Record<TLeadStatus, { label: string; className: string }> = {
  new: {
    label: 'New',
    className: 'bg-[#10B981]/20 text-[#10B981] border-[#10B981]',
  },
  contacted: {
    label: 'Contacted',
    className: 'bg-[#3B82F6]/20 text-[#3B82F6] border-[#3B82F6]',
  },
  qualified: {
    label: 'Qualified',
    className: 'bg-[#6366F1]/20 text-[#6366F1] border-[#6366F1]',
  },
  quote_sent: {
    label: 'Quote Sent',
    className: 'bg-[#A78BFA]/20 text-[#A78BFA] border-[#A78BFA]',
  },
  negotiation: {
    label: 'Negotiation',
    className: 'bg-[#D97706]/20 text-[#D97706] border-[#D97706]',
  },
  appointment_booked: {
    label: 'Appt Booked',
    className: 'bg-[#8B5CF6]/20 text-[#8B5CF6] border-[#8B5CF6]',
  },
  showing_scheduled: {
    label: 'Showing',
    className: 'bg-[#EC4899]/20 text-[#EC4899] border-[#EC4899]',
  },
  offer_made: {
    label: 'Offer Made',
    className: 'bg-[#F59E0B]/20 text-[#F59E0B] border-[#F59E0B]',
  },
  under_contract: {
    label: 'Under Contract',
    className: 'bg-[#F97316]/20 text-[#F97316] border-[#F97316]',
  },
  closed_won: {
    label: 'Closed Won',
    className: 'bg-[#10B981]/20 text-[#10B981] border-[#10B981]',
  },
  closed_lost: {
    label: 'Closed Lost',
    className: 'bg-[#EF4444]/20 text-[#EF4444] border-[#EF4444]',
  },
  nurture: {
    label: 'Nurture',
    className: 'bg-[#06B6D4]/20 text-[#06B6D4] border-[#06B6D4]',
  },
};

export const PipelineStageBadge = memo(function PipelineStageBadge({
  status,
  size = 'md',
}: IPipelineStageBadgeProps) {
  const config = stageConfig[status];

  return (
    <span
      className={cn(
        'inline-flex items-center justify-center rounded border font-medium whitespace-nowrap',
        config.className,
        size === 'sm' ? 'w-[110px] px-2.5 py-1 text-xs' : 'w-[120px] px-3 py-1.5 text-sm'
      )}
    >
      {config.label}
    </span>
  );
});
